// extracted by mini-css-extract-plugin
export default {"navList":"navList_navList__Qim7w"};